<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>考勤异常申诉详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTab">
        <div style="display: flex; justify-content: space-between">
          <div>
            <div class="infoItem">任务编号：{{ detail.jobNo }}</div>
            <div class="infoItem">任务名称：{{ detail.jobTitle }}</div>
            <div class="infoItem">
              申诉状态：{{
                detail.operateStatus == 0
                  ? "待审核"
                  : detail.operateStatus == 1
                  ? "审核通过"
                  : "审核拒绝"
              }}
            </div>
            <div class="infoItem">
              打卡时间：{{ detail.startTime }}至{{ detail.endTime }}
            </div>
            <div class="infoItem">
              打卡状态：{{
                detail.signStatus == 0
                  ? "未打卡"
                  : detail.signStatus == 1
                  ? "正常打卡"
                  : detail.signStatus == -1
                  ? "迟到打卡"
                  : "早退打卡"
              }}
            </div>
            <div class="infoItem">申诉人：{{ detail.appealName }}</div>
            <div class="infoItem">申诉原因：{{ detail.appealReason }}</div>
            <div class="infoItem">申诉时间：{{ detail.gmtCreate }}</div>
            <div class="infoItem">申诉提交信息：</div>
            <div style="display: flex; align-items: center; flex-wrap: wrap">
              <div v-for="(item, index) in detail.fileList" :key="index">
                <el-image
                  style="width: 100px; height: 150px; margin-right: 30px"
                  :src="item.url"
                  v-if="item.fileType == 0"
                  alt=""
                  :preview-src-list="[item.url]"
                ></el-image>
                <audio
                  v-if="item.fileType == 1"
                  style="width: 50px; height: 50px; margin-right: 10px"
                  ref="audioPlayer"
                  :src="item.url"
                  @play="handlePlay"
                  @pause="handlePause"
                  @timeupdate="updateTime"
                ></audio>
                <div style="text-align: center; margin: 5px 0 10px">
                  {{ item.fileName }}
                </div>
              </div>
            </div>
            <div class="infoItem">处理人：{{ detail.operatorName }}</div>
            <div class="infoItem">
              处理状态：{{
                detail.operateStatus == 0
                  ? "待审核"
                  : detail.operateStatus == 1
                  ? "审核通过"
                  : "审核拒绝"
              }}
            </div>
            <div class="infoItem">处理信息：{{ detail.rejectReason }}</div>
            <div class="infoItem">处理时间：{{ detail.operateAt }}</div>
          </div>
          <div class="box">
            <div style="margin: 10px 10px">
              <el-select
                v-model="workTime"
                @change="selectTime"
                placeholder="请选择考勤日"
                style="margin-right: auto; width: 240px"
              >
                <el-option
                  :label="item.key"
                  :value="item.dayNum"
                  v-for="(item, index) in detail.newTime"
                  :key="index"
                ></el-option>
              </el-select>
              <el-button
                @click="big()"
                type="primary"
                class="btn"
                style="height: 32px; line-height: 4px"
                >全屏</el-button
              >
            </div>
            <div id="map" style="width: 400px; height: 400px"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taskData(),
      workTime: "",
      editId: "",
      detail: {},
      selectStarTime: "",
      selectEndTime: "",
      gps: [],
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.getDetail();
    }
  },
  methods: {
    selectTime(val) {
      for (var i = 0; i < this.detail.newTime.length; i++) {
        if (val == this.detail.signTimeList[i].dayNum) {
          this.selectStarTime = this.detail.signTimeList[i].startAt;
          this.selectEndTime = this.detail.signTimeList[i].endAt;
          this.gps = [];
          this.getGps();
        }
      }
    },
    int() {
      const map = new AMap.Map("map", {
        resizeEnable: true,
        center: [this.detail.jobLog, this.detail.jobLat], // 地图中心点
        zoom: 13, // 地图显示的缩放级别
      });
      //半径中心点（任务地址）
      const address = new AMap.Marker({
        position: [this.detail.jobLog, this.detail.jobLat],
        // position: [116.502008, 39.786623],
        offset: new AMap.Pixel(-18, -36),
        content: `<img src="${require("@/assets/imgs/taskIcon.png")}" style="width:45px;height:55px"/>`,
        map: map,
      });
      address.setMap(map);
      //精度圈
      const circle = new AMap.Circle({
        center: new AMap.LngLat(this.detail.jobLog, this.detail.jobLat), // 圆心经纬度坐标
        radius: 100, // 圆半径，单位：米
        strokeColor: "#0093FF", // 圆边界颜色
        strokeWeight: 1, // 圆线宽
        fillColor: "#02B0FF", // 圆填充色
        fillOpacity: 0.25, // 圆填充透明度
      });
      // 将精度圈添加到地图上
      circle.setMap(map);
      // 添加轨迹线
      const markers = [];
      for (var i = 0; i < this.gps.length; i++) {
        let obj = {};
        obj.position = [this.gps[i].log, this.gps[i].lat];
        obj.time = this.gps[i].recordAt.substring(11, 16);
        markers.push(obj);
      }
      const path = [];
      for (var x = 0; x < markers.length; x++) {
        path.push(markers[x].position);
      }
      const polyline = new AMap.Polyline({
        path: path,
        strokeColor: "#3366FF", // 线颜色
        strokeOpacity: 1, // 线透明度
        strokeWeight: 6, // 线宽
        strokeStyle: "solid", // 线样式
      });
      polyline.setMap(map);
      markers.forEach((point, index) => {
        new AMap.Marker({
          position: point.position,
          content: `<div style="border-radius: 50%; width: 20px; height: 20px;border:3px solid #fff;background:#3366FF;position: relative;">
            <div style="position: absolute;top: -20px;left:-10px;padding:1px 1px;box-sizing: border-box;border-radius: 5px;color: red;background: #fff;color: #3366FF;">${point.time}</div>
            </div>`, // 自定义内容，显示序号
          map: map,
          offset: new AMap.Pixel(-10, -10), // 根据内容调整偏移量，使图标居中显示
        });
      });
      //精确到需要显示内容的位置
      map.setFitView();
    },
    getDetail() {
      this.$axios
        .post(`/admapi/sign/appeal/${this.editId}`)
        .then(({ data }) => {
          let obj = data;
          obj.startTime = obj.dueAtIn.substring(5, 16);
          obj.endTime = obj.dueAtOut.substring(5, 16);
          let arr = [];
          for (var i = 0; i < obj.signTimeList.length; i++) {
            let obj1 = {};
            obj1.key =
              "第" +
              obj.signTimeList[i].dayNum +
              "天(" +
              obj.signTimeList[i].startAt.substring(5, 16) +
              "至" +
              obj.signTimeList[i].endAt.substring(5, 16) +
              ")";
            obj1.dayNum = obj.signTimeList[i].dayNum;
            arr.unshift(obj1);
            arr.sort((a, b) => a.dayNum - b.dayNum);
            if (obj.signTimeList[i].dayNum == obj.dayNum) {
              this.selectEndTime = obj.signTimeList[i].endAt;
              this.selectStarTime = obj.signTimeList[i].startAt;
            }
          }
          obj.newTime = arr;
          this.detail = obj;
          this.workTime = obj.dayNum;
          this.getGps();
        })
        .catch()
        .finally();
    },
    getGps() {
      let parms = {
        jobNo: this.detail.jobNo,
        memberId: this.detail.appealId,
        queryEndDateTime: this.selectEndTime,
        queryStartDateTime: this.selectStarTime,
      };
      this.$axios
        .post(`/admapi/sign/getgps`, parms)
        .then(({ data }) => {
          this.gps = data;
          this.int();
        })
        .catch()
        .finally();
    },
    big() {
      const elem = document.getElementById("map"); // 获取地图容器元素
      if (elem.requestFullscreen) {
        elem.requestFullscreen(); // 标准方法
      }
    },
    play() {
      this.$refs.audioPlayer.play();
    },
    pause() {
      this.$refs.audioPlayer.pause();
    },
    stop() {
      this.$refs.audioPlayer.pause();
      this.$refs.audioPlayer.currentTime = 0;
    },
    handlePlay() {
      console.log("播放中");
    },
    handlePause() {
      console.log("已暂停");
    },
    updateTime(event) {
      this.currentTime = event.target.currentTime;
      this.duration = event.target.duration;
    },
  },
};
</script>
<style scoped>
.box {
  border: 1px solid #ccc;
}
.infoItem {
  margin-bottom: 10px;
}
</style>
